var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoguito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.9 124.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#54596e;}.cls-3{fill:#55a6ff;}.cls-4{fill:#fff35f;}.cls-5{fill:#d8d8d8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.7 26.58 30.06 17.61 29.15 12.85 34.09 7.54 51.93 7.54 57.66 3.33 67.06 2 72.66 4 78.46 3.15 84.84 7.91 87.36 12.85 107.86 10.62 96.88 26.58 97.06 98.59 61.73 105.11 24.64 98.59 24.64 38.73 3.7 26.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.64,101.59a2,2,0,0,1-2-2V31.3a2,2,0,1,1,4,0V99.59A2,2,0,0,1,24.64,101.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.95 112.2 60.49 121.12 20.04 112.2 20.04 98.59 60.49 105.4 100.95 98.59 100.95 112.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.49,123.12a2.1,2.1,0,0,1-.43-.05l-40.45-8.91a2,2,0,0,1-1.57-2V98.59a2,2,0,0,1,.71-1.53,2,2,0,0,1,1.62-.44l40.12,6.75,40.12-6.75a2,2,0,0,1,2.34,2v13.62a2,2,0,0,1-1.57,2l-40.46,8.91A2,2,0,0,1,60.49,123.12ZM22,110.6l38.45,8.47L99,110.6V101l-38.13,6.42a1.83,1.83,0,0,1-.66,0L22,101ZM101,112.21h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 60.49,
    cy: 113.68,
    r: 8.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.49,124.24a10.57,10.57,0,1,1,10.57-10.56A10.58,10.58,0,0,1,60.49,124.24Zm0-17.13a6.57,6.57,0,1,0,6.57,6.57A6.57,6.57,0,0,0,60.49,107.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.64,40.73a2,2,0,0,1-.91-.22L1.08,28.81a2,2,0,0,1,.31-3.68l26.29-8.39a7,7,0,0,1-.2-5.26c1.19-3,4.67-4.93,10.36-5.71,4-.52,12-.55,14.92-.54A13.06,13.06,0,0,1,63,0c4.58-.08,7,1,8.33,2l.21,0a16.43,16.43,0,0,1,7.33-.38,10.71,10.71,0,0,1,6.87,3.8,9,9,0,0,1,2.43,7.1c-.68,2.84-2.79,4.87-6.45,6.2a7.18,7.18,0,0,1-2,5.11c-1.91,2.17-6.87,5.82-18.65,5.82-12.51,0-18.52-4-21-6.4a6,6,0,0,0-2.68-1.54l-2.53-.65L30.69,20,7.21,27.48,25.56,37a2,2,0,0,1-.92,3.77Zm7.21-24.58,4,1,2.53.65a10.11,10.11,0,0,1,4.47,2.54c2,2,7.11,5.28,18.21,5.28,10.58,0,14.46-3.12,15.64-4.46a3.11,3.11,0,0,0,1-2.32A3.57,3.57,0,0,1,80.12,15C83.27,14,84,12.68,84.26,11.67A5.65,5.65,0,0,0,82.78,8.1a6.93,6.93,0,0,0-4.73-2.57,12.86,12.86,0,0,0-5.6.36l-.4.1A3.62,3.62,0,0,1,69,5.25C68.58,4.94,67.08,4,63.07,4a9.15,9.15,0,0,0-7.52,4.21,2,2,0,0,1-1.76,1c-.11,0-10.89-.1-15.42.49-5.41.75-6.81,2.33-7.16,3.2A3.9,3.9,0,0,0,31.85,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.63,101.31a2,2,0,0,1-2-2l0-71.56A22.25,22.25,0,0,0,85,14.53a2,2,0,0,1,2.15-3.37A25.77,25.77,0,0,1,98.56,27.21a1.87,1.87,0,0,1,0,.34l0,71.76a2,2,0,0,1-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.59,29.55A2,2,0,0,1,95,26.37l9.69-13.31L87,14.84a2,2,0,0,1-.4-4L108.7,8.63a2,2,0,0,1,1.82,3.17L98.21,28.73A2,2,0,0,1,96.59,29.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 60.49,
    cy: 63.89,
    rx: 6.28,
    ry: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.09,81.61a7.82,7.82,0,0,1-5.83-2.34c-2.77-2.93-2.62-7.39-2.6-7.89a2,2,0,0,1,4,.2c0,.9.15,3.52,1.51,4.94a3.83,3.83,0,0,0,2.92,1.09c4.93,0,5.39-6,5.41-6.26a2,2,0,0,1,4,.27C62.26,75.08,60,81.61,53.09,81.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.93,81.61a7.82,7.82,0,0,1-5.83-2.34c-2.77-2.93-2.63-7.39-2.6-7.89a2,2,0,0,1,4,.2c0,.9.15,3.52,1.51,4.94a3.83,3.83,0,0,0,2.92,1.09c4.93,0,5.39-6,5.4-6.26a2,2,0,0,1,4,.27C76.09,75.08,73.83,81.61,66.93,81.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 45.61,
    cy: 47.11,
    r: 6.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.61,
    cy: 43.05,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 75.56,
    cy: 47.11,
    r: 6.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75.56,
    cy: 43.05,
    r: 2.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoguito);
export default __webpack_public_path__ + "static/media/doguito.3541f9d895bc412844a5035a020012f9.svg";
export { ForwardRef as ReactComponent };